<!-- =========================================================================================
    File Name: SubscriptionPayment.vue
    Description: Subscription payment page
========================================================================================== -->

<template>
  <div>
    <vx-card class="overflow-auto">
      <vs-button icon-pack="feather" icon="icon-download" @click="exportExcel()">{{$t('EXPORT_EXCEL')}}</vs-button>
      <v-server-table id="subscription-payment-table" ref="subscriptionPaymentTable" name="subscriptionPaymentTable" 
        :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded" @sorted="setSortedForExcel" @filter="setFilterForExcelIncludeDateFilter">
        <vs-chip slot="paymentStatus" slot-scope="props" :color="getPaymentStatusColor(props.row.subscriptionPayment.paymentStatus)" class="w-full" >
          {{$t(setPaymentStatus(props.row.subscriptionPayment.paymentStatus))}}</vs-chip>
      </v-server-table>
    </vx-card>
  </div>
</template>

<script>
let FileSaver = require('file-saver');

import moduleSubscription from "@/store/subscription/moduleSubscription.js"

export default {
  components: {
  },
  data() {
    return {
      // Data Sidebar
      dataSidebar: false,
      sidebarData: {},
      
      // Table
      columns: ['userId', 'orderId', 'productStoreId', 'promotionYn', 'storeType', 'paymentStatus', 'billingDateTime', 'expiredDate', 'cancelDateTime'],
      options: {
        perPage:10,
        skin: 'table',
        filterByColumn: true,
        filterable: ['userId', 'orderId', 'productStoreId', 'promotionYn', 'storeType', 'paymentStatus', 'billingDateTime','expiredDate', 'cancelDateTime'],
        sortable: ['userId', 'orderId', 'productStoreId', 'promotionYn', 'storeType', 'paymentStatus', 'billingDateTime', 'expiredDate', 'cancelDateTime'],
        orderBy: { ascending: false },
        debounce: 1000,
        dateColumns: ['billingDateTime', 'receiptData', 'expiredDate', 'cancelDateTime'],
        dateFormat: 'YYYY-MM-DD',
        toMomentFormat: 'YYYYMMDD',
        datepickerOptions: {
            showDropdowns: true,
            autoUpdateInput: true,
        },
        sortIcon: {
          base: 'feather',
          up: 'icon-arrow-up',
          down: 'icon-arrow-down',
        },
        texts:{
            filterBy: this.$t("FILTER_BY"),
            defaultOption: this.$t("DEFAULT_OPTION"),
        },
        headings: {
          'userId': () => this.$t("USER_ID"),
          'orderId': () => this.$t("ORDER_ID"), 
          'productStoreId': () => this.$t("PRODUCT_STORE_ID"),
          'promotionYn': () => this.$t("PROMOTION_YN"),
          'storeType': () => this.$t("STORE_TYPE"),
          'paymentStatus': () => this.$t("PAYMENT_STATUS"),
          'billingDateTime': () => this.$t("BILLING_DATETIME"),
          'expiredDate': () => this.$t("EXPIRED_DATE"), 
          'cancelDateTime': () => this.$t("CANCEL_DATETIME"),
          'detail': () => this.$t("DETAIL")
        },
        listColumns:{
          promotionYn: [
            {
              id: 'Y',
              text: this.$t('PROMOTION_Y')
            },
            {
              id: 'N',
              text: this.$t('PROMOTION_N')
            }

          ],
          storeType: [
            {
              id: '1',
              text: this.$t('GOOGLE')
            },
            {
              id: '2',
              text: this.$t('APPLE')
            }
          ],
          paymentStatus: [
            { 
              id: '1',
              text: this.$t('ORDER_REQUEST') 
            },
            { 
              id: '2',
              text: this.$t('VERIFY_A_PURCHASE') 
            },
            { 
              id: '3',
              text: this.$t('PURCHASE_SUCCESS') 
            },
            { 
              id: '4',
              text: this.$t('FAILED_VERIFY') 
            },
            { 
              id: '5',
              text: this.$t('FAILED_PURCHASE') 
            },
            { 
              id: '6',
              text: this.$t('SUB_CANCELED') 
            },
            { 
              id: '7',
              text: this.$t('SUB_EXPIRED') 
            },
            { 
              id: '8',
              text: this.$t('REVOKED') 
            }
          ]
        },
        columnsClasses: {
            storeType: 'subscription-store',
            paymentStatus: 'payment-status'
        },
        requestAdapter: function(data) {

          if(data.query.billingDateTime){
            data.query = {...data.billingDateTimeAdditional, ...data.query}

            let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            let start = moment.tz(data.query.billingDateTime.start, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment.tz(data.query.billingDateTime.end, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            
            data.query.billingDateTimeUTC.start = start
            data.query.billingDateTimeUTC.end = end
          }

          if(data.query.expiredDate){
            data.query = {...data.expiredDateAdditional, ...data.query}

            let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            let start = moment.tz(data.query.expiredDate.start, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment.tz(data.query.expiredDate.end, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            
            data.query.expiredDateUTC.start = start
            data.query.expiredDateUTC.end = end
          }

          if(data.query.cancelDateTime){
            data.query = {...data.cancelDateTimeAdditional, ...data.query}

            let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            let start = moment.tz(data.query.cancelDateTime.start, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment.tz(data.query.cancelDateTime.end, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            
            data.query.cancelDateTimeUTC.start = start
            data.query.cancelDateTimeUTC.end = end
          }

          return {
            ascending: data.ascending,
            byColumn: data.byColumn,
            pageSize: data.limit,
            orderBy: data.orderBy ? data.orderBy : "billingDateTime",
            page: data.page,
            query: data.query,
            pageResult: ((data.page-1)*data.limit)
          };
        },
        params: {
          billingDateTimeAdditional:{
            billingDateTimeUTC: {
              start: '',
              end: ''
            },
          },
          expiredDateAdditional:{
            expiredDateUTC: {
              start: '',
              end: ''
            }
          },
          cancelDateTimeAdditional:{
            cancelDateTimeUTC: {
              start: '',
              end: ''
            }
          }
        },
        requestFunction: function (data) {
          return this.$http.get('/api/subscription-payment-management/subscription-payment', {
                params: data
          }).catch(function (e) {
                this.dispatch('error', e);
                this.$vs.loading.close()
          }.bind(this));
        },
        responseAdapter: (response) => {
          this.$store.commit('dataSubscription/SET_SUBSCRIPTION_PAYMENT',response.data)
          return {
            data: this.$store.state.dataSubscription.subscriptionPaymentList,
            count: this.$store.state.dataSubscription.subscriptionPaymentCount
          }
        },
        templates:{
          userId: function(h,row){
            return row.user.userId;
          },
          orderId: function(h,row){
            return row.subscriptionPayment.orderId;
          },
          productStoreId: function(h,row){
            return row.storeProduct.productStoreId;
          },
          promotionYn: function(h,row){
            let product = row.storeProduct.promotionYn;
            if(product === 'Y'){
              return this.$t('PROMOTION_Y')
            }else{
              return this.$t('PROMOTION_N')
            }
          },
          storeType: function(h,row){
            let type = row.subscriptionPayment.storeType
            return this.$t(this.$store.state.commonConfig.storeType.properties[type].name);
          },
          paymentStatus: function(h,row){
            return row.subscriptionPayment.paymentStatus
          },
          billingDateTime: function(h,row){
            let billindDateTime = row.subscriptionPayment.billingDateTime
            if(!billindDateTime){
              return "-"
            } else{
              let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
              let dateTime = this.$moment(billindDateTime,'YYYYMMDDHHmmss').format()
              let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')
              
              return dateTimeToLocal
            }
          },
          subscriptionCode: function(h,row){
              return row.subscriptionPayment.subscriptionCode;
          },
          expiredDate: function(h,row){
            let expiredDate = row.subscriptionPayment.expiredDate
            if (!expiredDate){
              return "-"
            } else{
              let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
              let dateTime = this.$moment(expiredDate,'YYYYMMDDHHmmss').format()
              let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD')
              
              return dateTimeToLocal
            }

          },
          cancelDateTime: function(h,row){
            let cancelDateTime = row.subscriptionPayment.cancelDateTime
            if (!cancelDateTime){
              return "-"
            } else{
              let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
              let dateTime = this.$moment(cancelDateTime,'YYYYMMDDHHmmss').format()
              let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')
              
              return dateTimeToLocal
            }
          }
        }
      }
    }
  },
  created() {
    if (!moduleSubscription.isRegistered) {
      this.$store.registerModule('dataSubscription', moduleSubscription)
      moduleSubscription.isRegistered = true
    }
  },
  mounted(){
     if (this.$route.params.userId) {
        this.setFilterForExcel({
          name: "userId",
          value: this.$route.params.userId
        })
        this.$refs.subscriptionPaymentTable.setFilter({
          userId: this.$route.params.userId
        })
     }
  },
  methods: {
    // Sidebar
    toggleDataSidebar(val=false) {
      this.dataSidebar = val
    },
    seeDetail(data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getPaymentStatusColor(status){
      return this.$store.state.commonConfig.paymentStatus.properties[status].color
    },
    setPaymentStatus(status) {
      return this.$store.state.commonConfig.paymentStatus.properties[status].name
    },
    exportExcel(){

      let locale = this.$i18n.locale

      this.$http({
        method: 'post',
        url: '/api/subscription-payment-management/subscription-payment/excel/'+locale,
        data:{
          query : JSON.stringify(this.filterForExcel),
          orderBy:  this.sortForExcel.column ? this.sortForExcel.column : 'billingDateTime' ,
          ascending: this.sortForExcel.ascending ? 1 : 0,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        },
        withCredentials: true,
        responseType: 'blob',
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }).then((response) => {
        let excelTitle
        if (locale === "ko") {
          excelTitle = "구독_결제_목록.xlsx"
        } else {
          excelTitle ="Subscription_Payment_List.xlsx"
        }
        FileSaver.saveAs(response.data, excelTitle)
      }).catch((error)=> {
        console.log(error);
      }) 
    }
  },
}

</script>

<style lang="scss" scoped>
#subscription-payment-table {
  text-align: center;
}
</style>